import React, { useEffect } from 'react'

import Search from './Search'

const Component = ({
  engine,
  microcopy
}) => {
  // When the selected changes, make sure to scroll 
  // to that selected item
  useEffect(() => {
    const query = `li[data-index="${engine.state.selected}"]`
    const element = document.querySelector(query)
    if (element) { element.scrollIntoView(false) }
  }, [engine.state])


  return <Search engine={engine} microcopy={microcopy} />
}

export default Component
export { default as Engine } from './Engine'
export const defaultState = {
  showSearch: false,
  showSearchButton: false,
  results: [],
  query: null,
  filters: {
    'Guide': true,
    'Endpoint': true,
    'Resource': false,
    'Param': false
  },
  selected: 0
}
